module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "chap"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMPETENCY")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INETEEN")]), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TTRACTING")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OP")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALENT")])]), _vm._v(" "), _c('p', {
    staticClass: "quote",
    staticStyle: {
      "margin-top": "4em"
    }
  }, [_c('span', {
    staticClass: "no-style-override"
  }, [_vm._v("If you think hiring professionals is expensive, try hiring amateurs.")])]), _vm._v(" "), _c('p', {
    staticClass: "quote-2"
  }, [_c('b', [_vm._v("—Unknown")])]), _vm._v(" "), _c('p', {
    staticClass: "block-quote block-quote-override",
    staticStyle: {
      "margin-top": "4em",
      "margin-bottom": "2.9em"
    }
  }, [_c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("Attracting Top Talent:")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v(" Drawing in, recruiting, selecting, ")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("and hiring top performers.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text body-text-override"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("L")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("eading and developing top talent starts with attracting and")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v(" hiring top talent. Great leaders who develop high performers start by winning the recruiting battle and hiring the best people available. Like a fine restaurant, they start with the best ingredients. They hand-select their raw materials.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("There is a battle in the labor market for top performers. ")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("Organizations that don’t compete well end up with the leftovers. Leaders who don’t attract and hire top talent end up with the B players instead of the A players. Like a sports coach who doesn’t do well in the draft, leaders who don’t hire well have a lot more work to do than those who recruit the top picks. Instead of starting their season with a strong roster and competitive advantage, they start their season at a disadvantage.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The cost of not getting the right employees onboard is significant. Studies find that one in three new hires fails to meet performance expectations. Studies also find that average performers perform at less than half the level of their top-performing counterparts. In other words, you receive two employees for the price of one when you have a top performer.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Hiring top talent starts by attracting top talent. Great leaders manifest attributes and create environments that make the most talented people aspire to work for them.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Jeff was my neighbor who became a client and great friend. He is the CEO of a small insurance company. Everyone wants to spend time with him or work for him. He has acquaintances in the community, industry, and numerous social circles. I can’t count the times I’ve seen him in a newspaper photo with a celebrity or while on a vacation toasting a glass of wine to someone famous.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Jeff attracts talented and successful people because he has an endearing way about him. He is friendly, humble, competent, and likable. He makes people his top priority. He genuinely cares for others as evidenced by his frequent involvement in community affairs and nonprofit organizations.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When you spend time with Jeff, you have fun regardless of what you do. There is no pretentiousness. There is no arrogance. There is just enjoyable and engaging conversation. You experience an honest sharing of opinions, his great listening skills, and his genuineness.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Because Jeff frequently ventures out and puts himself in new situations, he meets many new people. Because of his giving nature, he finds opportunities to help people. As a result, he is highly respected by everyone and is someone others want to work with.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("How well do you attract top performers? Do you create an environment that attracts people to you? Here is a simple test to ")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("see how well you are doing. Pull out a notepad and make a list of ")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("your direct-reporting employees. Rate them in terms of how well ")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("they perform. Make another list of your five closest peers or business partners. Rate their performance in their respective roles. List your five closest friends and rate their qualities as friends. When you’re done, look at the quality of the people on your lists. Those who currently surround you are a good indication of the type of people you attract.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("Great leaders create a performance advantage by attracting and hiring the best people possible. They take advantage of recruiting opportunities at industry events and college job fairs. They attract people by leveraging advertising, speaking engagements, publishing, online job postings, and their organization’s online presence. Most importantly, though, they personally attract people and build organizations that people want to join. They attract top talent through these core attributes:")])]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "margin-top": "0em"
    }
  }, [_c('li', [_vm._v("People Focus")]), _vm._v(" "), _c('li', [_vm._v("Competence")]), _vm._v(" "), _c('li', [_vm._v("Opportunity")]), _vm._v(" "), _c('li', [_vm._v("Need")]), _vm._v(" "), _c('li', [_vm._v("Fit")]), _vm._v(" "), _c('li', [_vm._v("Advancement")]), _vm._v(" "), _c('li', [_vm._v("Respect")]), _vm._v(" "), _c('li', [_vm._v("Offer")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("For information on leveraging events and networking for ")]), _vm._v("potential new hires, refer to "), _c('span', [_vm._v("competency 26")]), _vm._v(" in book 5 of this series.")]), _vm._v(" "), _c('p', {
    staticClass: "headline",
    attrs: {
      "id": "linking145"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EOPLE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OCUS")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text body-text-override"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("Great leaders surround themselves with high-performing people. You hardly ever see them alone. At any given moment, they are encouraging, enabling, coaching, or working with someone. They see their goals through the lens of people rather than tasks. When they have an issue or an opportunity, they turn to people. They are people-focused.")])]), _vm._v(" "), _c('div', {
    staticClass: "callout-text-frame"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/l1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "callout-text"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASK")]), _vm._v("-"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CENTERED"), _c('br'), _vm._v(" LEADERS LEAD"), _c('br'), _vm._v(" THROUGH SPREADSHEETS,"), _c('br'), _vm._v(" REPORTS, AND"), _c('br'), _vm._v(" PROJECT PLANS.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/l1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("In contrast, managers who are not people-centric emphasize tasks, processes, and measurements. Task-centered leaders lead through spreadsheets, reports, and project plans. They spend time creating charts and managing budgets rather than working with people. When they see an issue or opportunity, they focus on the issue or opportunity, not the people they need to engage. They see their goals through the accomplishment of work rather than through the engagement of people.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Leaders who are people-focused value relationships. They don’t merely pursue relationships for their benefit. They are not like self-centered salespeople who show up only when they want to make a sale or “friends” who call only when they need help.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("This is not to say that people-focused leaders don’t care about numbers, goals, projects, plans, processes, systems, and tasks. They do, but they put people first. They see their organization as a team that in turn takes care of the processes, systems, controls, and results. People-focused leaders are like thoughtful salespeople who show up between orders to check on their customers.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When you start planning your day, do you first think about tasks to accomplish, or do you think about your people and what you need to do to enable, encourage, assist, and lead them? If there is any doubt, look at your to-do list. Does it contain more people-enabling activities or more domain-related tasks?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("If you are going to be a great leader of people and attract top talent, turn your focus to people. Give your attention to people activity first and tasks second. Focus on what you can do for your employees that will enable them to take care of the tasks.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("People know when you are focused on them or something else. You can’t hide it. How you fundamentally view people either repels or attracts them. When you are a people-focused leader, you spend your time recruiting, helping, and facilitating rather than doing. You regularly conduct one-on-one meetings, new-hire interviews, new-hire orientations, and human resource reviews. You coach and mentor. You maintain accountability. You walk the halls and job sites, talking to people frequently. You view your employees as the end, not the means to the end.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("When you focus on people, you go to places where you meet people. You build relationships, causing others to invite you to ")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("attend professional and community events. You regularly attend ")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("conferences and association gatherings. You become involved in ")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("community affairs and volunteer work. You engage in a variety of ")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("activities that allow you to meet new people and build your network as described in ")]), _c('span', {
    staticClass: "hyperlink hyperlink-override"
  }, [_vm._v("competency 26 in book 5")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("One of the primary issues preventing managers from focusing on their people is their "), _c('span', {
    staticClass: "no-style-override-3"
  }, [_vm._v("busyness")]), _vm._v(". Most managers try to do too much themselves. They take on more than they can reasonably handle. They fill every minute of their calendar. They get into such a habit of busyness that they repeat it even at home. They pack in as much into their evenings and weekends as they do in their workdays. In the few minutes they have left that aren’t scheduled, they squeeze in only brief interactions with their colleagues, family, friends, and neighbors. They leave virtually no time for the people in their lives—personally or professionally.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Great leaders make time to build and nurture relationships. They find a healthy balance between the needs of the business and the needs of their employees. They see work and life through people. They accomplish work by helping, coaching, enabling, and leading people. They know that their true value to the organization, and their ensuing legacy is based on the service, support, encouragement, and development of the people they lead.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("If your to-do list is more about completing tasks than working with people, start replacing your tasks with people interactions. Make people and working through them your first priority.")]), _vm._v(" "), _c('p', {
    staticClass: "headline",
    attrs: {
      "id": "linking146"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMPETENCE")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text body-text-override"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("Competence attracts competence. Incompetence attracts incom")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("petence. The principle of attraction is no more noticeable than in ")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("the recruiting process. Like attracts like. If you expect to attract ")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("competent people, you must be competent yourself.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("If you want to attract a certain quality, manifest it yourself. If you want to attract fearless people, exude courage and boldness. ")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("If you expect to attract conscientious sales candidates, exhibit ")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("conscientiousness yourself. If you frequently catch the wrong type of candidates in your recruiting funnel, don’t just put your hiring process under the microscope—look in the mirror. It may be that you or others in your hiring process are not manifesting the qualities you are looking for.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("Top performers like to work with leaders and teammates who ")]), _vm._v("are confident and competent. They respect those who are experts "), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("in their domain. They like to associate with positive people who ")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("have can-do attitudes. If these are the qualities you are looking ")]), _vm._v("for, ensure you and your hiring managers possess them. Don’t put your least talented or most pessimistic employees in the position of making a positive impression on your new-hire candidates. The "), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("positive impression won’t come through. ")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("In a new-hire interview setting, your hiring managers become ")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("the manifestation of your brand image. They are the face of your organization. The qualities and competence they display ")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("are the filters through which your new-hire candidates see your ")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("organization. You might have a high-energy culture that promotes ")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("bold decision making, but if your hiring manager is timid and ")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("talks in a monotone, your hiring candidates won’t know your true ")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("culture.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("As a new hire’s manager, you are the most important aspect of the hiring process. Your competence, attitude, values, and style are what a candidate sees and therefore what matters most. Candidates base how well they expect to work in your organization on how well they interact with you during the interviewing process. Take your interviewing meetings and interactions very seriously. Be at the top of your game. Manifest the top-performer qualities you are looking for in others. You more than anything else determine whom you attract. For additional information on building competence and being a leader for whom people want to work, see book 2 of this series—")]), _c('span', {
    staticClass: "no-style-override-3"
  }, [_vm._v("Self: Setting the Example")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "headline",
    attrs: {
      "id": "linking147"
    }
  }, [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PPORTUNITY")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text body-text-override"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("In the interviewing process, there are two interviews taking place. You are interviewing candidates, and they are interviewing you. From your perspective as the hiring manager, you want to get to know them and evaluate their ability to perform. You assess how well they fit into the positions you need to fill. You ask questions to understand how they respond to certain situations. You ask for past examples of the desired behaviors and attitudes you are looking for. You seek to validate the claims they made in their preinterview assessments and resume. Your objective is to make a comprehensive evaluation of their philosophies, interests, attitudes, skills, and fit.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Unless your hiring candidates are looking for just a paycheck, they are also interviewing you. They evaluate you, your organization, and the people with whom they will work. They inquire about the characteristics of the available position. They assess your competence and character. They want to know if you and your opportunity are a good fit for them.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("Top performers look at their employment opportunities from ")]), _vm._v("many perspectives. Foremost, they want to use their skills and have "), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("a reasonable chance of being successful. They want to be part of a winning team, a team of other top performers. They want to be on ")]), _vm._v("the forefront of something. They need to see a compelling vision, "), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("strategy, and plan, as well as resources and tools that will enable them ")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("to perform at the highest level. They want a reasonable expense budget ")]), _vm._v("and decision-making authority. They want the ability to accomplish "), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("their job without overly restrictive policies and approvals.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Top performers expect opportunities for advancement and recognition. They want to know the direction your business unit, division, and organization are headed. They will ask about upcoming product launches, marketing campaigns, and potential acquisitions. They will ask questions about the basis on which you expect to grow the organization and be successful.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Be prepared when you interview top performers. Don’t have just your behavioral interviewing questions ready. Have your "), _c('span', {
    staticClass: "no-style-override-3"
  }, [_vm._v("sales presentation")]), _vm._v(" ready. As you would recruit a new customer, be prepared to deliver a well-thought-out and compelling value proposition. For candidates you hope to hire, review all the features and benefits that make your organization an attractive place to work. Present an opportunity they will find attractive.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Compensation is the anchor around which most hiring discussions take place. It is top of mind for both the candidate and the hiring manager. However, there are many other considerations that top performers are concerned about. Don’t substitute money for other important considerations. Once people make enough money to live a comfortable lifestyle, money becomes less important than many managers think.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("Table 4.1 lists what surveys consistently find to be the ")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("qualities that top performers are most attracted to in addition to ")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("compensation.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('table', {
    staticStyle: {
      "width": "99%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "table-header",
    attrs: {
      "id": "tab4.1"
    }
  }, [_c('span', {
    staticClass: "no-style-override-9"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ABLE")]), _vm._v(" 4.1: Q"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UALITIES")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAT")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TTRACT")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OP")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERFORMERS")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "45%"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('ul', {
    staticStyle: {
      "margin-top": "1em",
      "margin-bottom": "0em",
      "margin-left": "0em"
    }
  }, [_c('li', [_vm._v("Professional development")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "45%"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('ul', {
    staticStyle: {
      "margin-top": "1em",
      "margin-bottom": "0em",
      "margin-left": "1em"
    }
  }, [_c('li', [_vm._v("Job stability")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "45%"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('ul', {
    staticStyle: {
      "margin-top": "1em",
      "margin-bottom": "0em",
      "margin-left": "0em"
    }
  }, [_c('li', [_vm._v("Interesting work")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "45%"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('ul', {
    staticStyle: {
      "margin-top": "1em",
      "margin-bottom": "0em",
      "margin-left": "1em"
    }
  }, [_c('li', [_vm._v("Enjoyable workplace culture")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "45%"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('ul', {
    staticStyle: {
      "margin-top": "1em",
      "margin-bottom": "0em",
      "margin-left": "0em"
    }
  }, [_c('li', [_vm._v("Organizational pride")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "45%"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('ul', {
    staticStyle: {
      "margin-top": "1em",
      "margin-bottom": "0em",
      "margin-left": "1em"
    }
  }, [_c('li', [_vm._v("Compatible team members")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "45%"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('ul', {
    staticStyle: {
      "margin-top": "1em",
      "margin-bottom": "0em",
      "margin-left": "0em"
    }
  }, [_c('li', [_vm._v("A competent, respectful, likable manager")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "45%"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('ul', {
    staticStyle: {
      "margin-top": "1em",
      "margin-bottom": "0em",
      "margin-left": "1em"
    }
  }, [_c('li', [_vm._v("Flexibility; work and life balance")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "45%"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('ul', {
    staticStyle: {
      "margin-top": "1em",
      "margin-bottom": "0em",
      "margin-left": "0em"
    }
  }, [_c('li', [_vm._v("Opportunity for accomplishment; realistic expectations and objectives")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "45%"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('ul', {
    staticStyle: {
      "margin-top": "1em",
      "margin-bottom": "0em",
      "margin-left": "1em"
    }
  }, [_c('li', [_vm._v("Opportunity to advance")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("To attract top talent, create and offer positions that provide as many of these qualities as possible. Review these with your new-hire candidates as a veteran salesperson would in a sales presentation. Present a compelling value proposition that makes the position to be filled most appealing. Give examples and allow sufficient time for the candidates to ask their questions. When you are attracting top talent, you are in an intense competition. Give them an attractive employment opportunity if you expect to bring them onboard.")])]), _vm._v(" "), _c('p', {
    staticClass: "headline",
    attrs: {
      "id": "linking148"
    }
  }, [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EED")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text body-text-override"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("There are two types of hiring needs. One is hiring for a specific role or a specific position you need to fill. The other is for general talent. In the latter, the need is for a general role or to-be-determined position that you will fill based on the individual’s talents and the organization’s needs.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("Both hiring needs require knowing the knowledge, skills, ")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("attitudes, and experiences you are looking for before you start recruiting. The needs for both types of hiring include general characteristics and competencies such as integrity, good communication skills, a team orientation, and a positive attitude. The more specific roles also require domain knowledge, domain skills, and experience related to the position being filled.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("To attract and hire the right candidates, be clear about your hiring needs before you start recruiting. Build a profile of the specific attributes you are looking for. Without a hiring profile, you will merely hire people you like instead of people ")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("you need. Without proper plan")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("ning, managers unknowingly hire and build teams that have their same personality, background, and ability. There are exceptions where managers seek to hire their opposites to offset their own shortcomings, but managers often gravitate unconsciously toward those like themselves. Having a team of similarly minded and capable people works well in settings where everyone works primarily as individuals but has significant limitations in environments where people are expected to perform different functions and work as a team.")])]), _vm._v(" "), _c('div', {
    staticClass: "callout-text-frame"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/l1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "callout-text"
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITHOUT A HIRING"), _c('br'), _vm._v(" PROFILE, YOU WILL"), _c('br'), _vm._v(" MERELY HIRE PEOPLE"), _c('br'), _vm._v(" YOU LIKE INSTEAD OF"), _c('br'), _vm._v(" PEOPLE YOU NEED.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/l1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("You can easily spot a team lacking in diversity. They routinely sit in meetings together mindlessly agreeing to decisions with little debate. They all see problems and opportunities from the same perspective. Like a basketball team of only point guards, duplicated capabilities create a team with narrow abilities and limited ideas that performs well below its potential.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Perhaps you have been successful for many years but realize that your individual path to success isn’t the only one. You might have been successful because of your analytical reasoning and logical decision making, but other people are just as successful using their artistic and creative ability. Great teams have variety in their personalities, talents, experiences, and skills.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Whether hiring for similar capabilities or unique ones, be intentional about whom you hire. Build a profile of the characteristics and values that are most important to your organization’s needs. Focus on the position’s core requirements and allow flexibility in the areas that are not absolutes. By not constraining the position’s requirements too tightly, you will attract diversity that you would not otherwise attract. Honorable character and passion, for example, might be critical characteristics, while personality traits such as compliancy and meticulousness might not be.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Table 4.2 provides a list of attributes to consider in building your hiring profile.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "table-header",
    attrs: {
      "id": "tab4.2"
    }
  }, [_c('span', {
    staticClass: "no-style-override-7"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ABLE")]), _vm._v(" 4.2: H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRING")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROFILE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TTRIBUTES")])])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Presence:")]), _c('span', {
    staticClass: "no-style-override-8"
  }, [_vm._v(" appearance, outward respectability")]), _c('br'), _c('br')]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Likability: ")]), _c('span', {
    staticClass: "no-style-override-8"
  }, [_vm._v("personality, friendliness ")]), _c('br'), _c('br')]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Persistence: ")]), _c('span', {
    staticClass: "no-style-override-8"
  }, [_vm._v("determination, doggedness, focus, competitive drive")]), _c('br'), _c('br')]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Conscientiousness:")]), _c('span', {
    staticClass: "no-style-override-8"
  }, [_vm._v(" commitment to follow-through, thoroughness, desire for quality")]), _c('br'), _c('br')]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Enthusiasm:")]), _c('span', {
    staticClass: "no-style-override-8"
  }, [_vm._v(" energy, passion for the position")]), _c('br'), _c('br')]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Character:")]), _c('span', {
    staticClass: "no-style-override-8"
  }, [_vm._v(" honesty, integrity")]), _c('br'), _c('br')]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Confidence:")]), _c('span', {
    staticClass: "no-style-override-8"
  }, [_vm._v(" poise, resilience, willingness to take responsibility")]), _c('br'), _c('br')]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Experience: ")]), _c('span', {
    staticClass: "no-style-override-8"
  }, [_vm._v("industry knowledge, domain expertise, past achievements, encounters with adversity")]), _c('br'), _c('br')]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Intellect:")]), _c('span', {
    staticClass: "no-style-override-8"
  }, [_vm._v(" reasoning, speed of learning, general knowledge (note: studies find consistently that people’s general intellectual ability only accounts for 10-20% of their performance)")]), _c('br'), _c('br')]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Values:")]), _c('span', {
    staticClass: "no-style-override-8"
  }, [_vm._v(" guiding principles, philosophies, beliefs")]), _c('br'), _c('br')]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Flexibility:")]), _c('span', {
    staticClass: "no-style-override-8"
  }, [_vm._v(" adaptability, comfort with change")]), _c('br'), _c('br')]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Communications")]), _c('span', {
    staticClass: "no-style-override-8"
  }, [_vm._v(": skill in writing, speaking, listening")]), _c('br'), _c('br')]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Work Ethic:")]), _c('span', {
    staticClass: "no-style-override-8"
  }, [_vm._v(" level of productivity, commitment, stability, discipline ")]), _c('br'), _c('br')]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("External Perspective: ")]), _c('span', {
    staticClass: "no-style-override-8"
  }, [_vm._v("business acumen, big-picture thinking, customer focus")]), _c('br'), _c('br')]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Authenticity: ")]), _c('span', {
    staticClass: "no-style-override-8"
  }, [_vm._v("transparency, genuineness")]), _c('br'), _c('br')]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Manageability: ")]), _c('span', {
    staticClass: "no-style-override-8"
  }, [_vm._v("willingness to follow and take direction")]), _c('br'), _c('br')]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Organization Fit:")]), _c('span', {
    staticClass: "no-style-override-8"
  }, [_vm._v(" team and cultural fit")]), _c('br'), _c('br')]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Creativity: ")]), _c('span', {
    staticClass: "no-style-override-8"
  }, [_vm._v("ability to think creatively, brainstorm, and contribute new ideas")]), _c('br'), _c('br')]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Desire to Improve: ")]), _c('span', {
    staticClass: "no-style-override-8"
  }, [_vm._v("desire to learn and continuously improve")]), _c('br'), _c('br')]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Self-Driven: ")]), _c('span', {
    staticClass: "no-style-override-8"
  }, [_vm._v("self-starting, intentional, proactive")]), _c('br'), _c('br')]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Team Player: ")]), _c('span', {
    staticClass: "no-style-override-8"
  }, [_vm._v("collaborative, interest in helping others")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Put objectivity into your selection process by defining the specific needs you have for the positions you need to fill. Build scorecards to help grade, compare, and rank your candidates. If some attributes are more important than others, apply weighting criteria to your profile. If you have ten core attributes, rather than weight each of them equally at 10 percent, weight the most important ones higher and the less important ones lower.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("For specific positions as opposed to general recruiting, have a clearly defined role description in addition to a hiring profile. For additional information on developing job descriptions, see the section on defined roles in "), _c('span', [_vm._v("competency 27 in book 5")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "headline",
    attrs: {
      "id": "linking149"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IT")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text body-text-override"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("For each of the characteristics you put in your hiring profile, identify ")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("the questions or experiences you want to understand to verify that a candidate has the level of proficiency you need. If you are looking for people who are passionate about the work you do, decide how you will evaluate a candidate’s passion for your position. Rather than infer someone’s passion from a resume, identify questions you will ask and what you will explore in the interviewing process. Know what level of engagement, type of body language, degree of enthusiasm, or past behavior you are looking for.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("For example, one way to understand candidates’ passion in an ")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("area is to find out how much time, money, and energy they’ve invested ")]), _vm._v("in it. A history of working 8:00 a.m. to 5:00 p.m. shows they did "), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("their job but doesn’t demonstrate much passion for it. In comparison, ")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("reading twenty books they bought with their own money, working ")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("through lunch breaks for several months during an important project, and volunteering for special assignments are good signs of passion.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Create a spirited conversation in your hiring interviews. Move into deeper levels of conversation such as those outlined in the section on inquiry in "), _c('span', [_vm._v("competency 17 in book 3")]), _vm._v(". Ask challenging "), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("questions that require thought and experience to answer. For")]), _vm._v(" example, don’t merely ask people if they like working as part of a team. It’s not only a closed-ended question but too easy to answer affirmatively. Ask open-ended questions that require candidates to provide explanation and increase their self-disclosure. Ask for specific examples of when they worked as a team. Ask under what conditions they like working alone versus working as a team. Ask them to describe what they do that makes other people value them as a team member rather than an individual contributor. Move past people’s professional facade and get to know who they truly are.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("Avoid leading questions that give away the answer you are looking for. Don’t ask a question like, “Do you coach your team to help them develop?” Instead ask, “How do you impact the professional development of your team?” Neither should you ask people only about their accomplishments and what they do well. As importantly, ask them to describe when and how they have struggled. Understand how they make up for their shortcomings and what they do to improve.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("To be prepared for your hiring interviews, have your profile of the characteristics you need, the level of proficiency expected for each characteristic, and how you will validate that candidates meet your criteria. Use their resumes as only a cursory part of your validation process. Resumes can be very poor reflections of people’s actual abilities. Of the twenty-one desirable hiring characteristics listed in Table 4.2, only ")]), _c('span', {
    staticClass: "no-style-override-3"
  }, [_vm._v("experience")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v(" comes out in a person’s resume. Instead of resumes, use behavioral interviewing questions, assessments, and references to evaluate people’s abilities and their fit for your position.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("As a note of caution, be wary of people whose interview answers seem polished to perfection. Their expertise could be in ")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("interviewing rather than in the domain you are seeking to fill. Or worse, they could be psychopaths. Paul Babiak and Robert D. Hare, authors of ")]), _c('span', {
    staticClass: "no-style-override-3"
  }, [_vm._v("Snakes in Suits: When Psychopaths Go to Work")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v(", find that around 3 percent of seemingly high-potential employees are psychopathic. They typically interview very well and manifest traits that are indiscernible from many leadership qualities. Psychopaths exude confidence and remain cool under pressure. They are action-oriented, courageous, charismatic, and influential. Being a skilled interviewer is critical to knowing whom you are interviewing.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Listed in Table 4.3 is a summary of interviewing best practices to help you accurately assess a candidate’s fit rather than basing your decision on their resume or interviewing skills.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "table-header",
    attrs: {
      "id": "tab4.3"
    }
  }, [_c('span', {
    staticClass: "no-style-override-7"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ABLE")]), _vm._v(" 4.3: I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTERVIEWING")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EST")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RACTICES")])])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticClass: "no-style-override-8"
  }, [_vm._v("Prior to the interview, define the characteristics you are looking for, how you expect to validate them in the interview, and how you will grade them.")]), _c('br'), _c('br')]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "no-style-override-8"
  }, [_vm._v("In the interview, ask your validating questions before telling the candidate the specific characteristics you are looking for. Otherwise you will simply hear a replay of the characteristics you asked for.")]), _c('br'), _c('br')]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "no-style-override-8"
  }, [_vm._v("Ask for multiple and specific examples where a desired behavior has been previously demonstrated.")]), _c('br'), _c('br')]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "no-style-override-8"
  }, [_vm._v("Ask challenging questions, probe for specifics, and uncover underlying details; increase the candidate’s self-disclosure.")]), _c('br'), _c('br')]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "no-style-override-8"
  }, [_vm._v("Use open-ended and nonleading questions like “Tell me about a time when you . . . ,” “Give me an example of a situation where you . . . ,” or “How would you handle. . . .”")]), _c('br'), _c('br')]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "no-style-override-8"
  }, [_vm._v("Use hypothetical scenarios and assessments to help reveal the candidate’s true preferences, philosophies, and abilities.")]), _c('br'), _c('br')]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "no-style-override-8"
  }, [_vm._v("Interview and assess until you understand with confidence how well candidates possess the competencies and proficiencies you are looking for.")]), _c('br'), _c('br')]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "no-style-override-8"
  }, [_vm._v("Allow time after your questions for candidates to interview you, for them to ask you questions, and for you to explain in more detail the features and benefits of the position should they be someone you want to hire.")]), _c('br'), _c('br')]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "no-style-override-8"
  }, [_vm._v("Following the interview, check their references, prior managers, former coworkers, past subordinates, other interviewers, or other information sources to confirm your assessment.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("Finding the right candidate who makes a good fit requires honesty on both sides. You obviously hope that candidates are honest about their capabilities so you obtain the capabilities you think you are bringing onboard. Just as important, you need to be honest about the position you are offering them. Any misrepresentation you make about the position, your organization, or the compensation will create future issues. Studies find that 80 percent of employee turnover can be traced to hiring mistakes, which are often based on false expectations set by the hiring manager. You might be most concerned about the candidate’s truthfulness, but yours is just as important.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("In securing candidates’ commitments, avoid the temptation ")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("to give them any false hope for a near-term raise or promotion. ")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("If you have the full intention to offer one, fine. If you know it ")]), _vm._v("won’t likely happen, don’t commit it. Making false promises might bring someone onboard, but it will quickly lead to frustration and resentment. You will soon find yourself right back where you started and looking for another candidate but having wasted your time and money on the prior one.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("In my coaching work, I frequently encounter disgruntled ")]), _vm._v("employees who were led to believe they would receive a promotion, raise, increase in responsibility, stock options, or some other perk by their manager. It happens both in the hiring process and during annual performance reviews. The end result is always the same. When managers don’t deliver on the expectations they set, employees become frustrated and demotivated. Either they quit or, worse, they stay and infect others with their frustration.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("If for some reason you want someone to quit, then frustrate them with expectations you know you can’t meet. However, if you want to keep your new hires and top performers, promise only what you can deliver. If they ask to be considered for a promotion within the next year and you know it won’t realistically happen, don’t tell them it will. Tell them instead about what you can do to help them develop, gain exposure, or advance their career in other ways. They will respect you more for telling the truth than they will for giving them false hope. Be honest about the role you need filled and the expectations you set for it.")])]), _vm._v(" "), _c('div', {
    staticClass: "callout-text-frame"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/l1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "callout-text"
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("F YOU WANT TO KEEP"), _c('br'), _vm._v(" YOUR NEW HIRES AND"), _c('br'), _vm._v(" TOP PERFORMERS,"), _c('br'), _vm._v(" PROMISE ONLY WHAT"), _c('br'), _vm._v(" YOU CAN DELIVER.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/l1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("To help ensure you and other hiring managers hire the right people, create a simple interviewing guide for everyone in the interviewing process to follow. Include a scorecard for managers to use to rate the candidates. It will guide managers to ask the right questions and avoid the wrong ones. It will help provide consistency in the evaluation process and put objectivity into the final hiring decision.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("Table 4.4 lists the essential elements to include in your interviewing guide.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "table-header",
    attrs: {
      "id": "tab4.4"
    }
  }, [_c('span', {
    staticClass: "no-style-override-9"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ABLE")]), _vm._v(" 4.4: E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEMENTS TO")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NCLUDE IN A")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRING")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTERVIEW")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UIDE")])])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticClass: "no-style-override-8"
  }, [_vm._v("Job description of the position being filled")]), _c('br'), _c('br')]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "no-style-override-8"
  }, [_vm._v("Attributes, values, and characteristics needed in the position")]), _c('br'), _c('br')]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "no-style-override-8"
  }, [_vm._v("Behavioral interviewing questions that validate the needed attributes")]), _c('br'), _c('br')]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "no-style-override-8"
  }, [_vm._v("Scorecard to measure the candidate’s proficiency level against the proficiency levels required for the position")]), _c('br'), _c('br')]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "no-style-override-8"
  }, [_vm._v("Guidelines for how to describe the attractive aspects of the position as well as what not to say, ask, or promise")])])])]), _vm._v(" "), _c('p', {
    staticClass: "headline",
    attrs: {
      "id": "linking150"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DVANCEMENT")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text body-text-override"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("Top performers like challenges. They don’t want to settle into ")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("comfortable habits of repetitious work. They look for opportunities to learn and take their skills to the next level. They look for increasing levels of responsibility. They look for opportunities to reach higher levels of accomplishment. Like an adrenaline junkie, they need higher achievements to hold their interests and stay challenged. They want to advance. Like great leaders, top performers aren’t satisfied with the status quo.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("Top performers like high standards. They want to work for ")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("organizations that have high expectations and rise above their industry peers. They like the exclusivity of being at the top. They expect to be part of a growing organization that has a vision to achieve something impressive. They are not attracted to mediocre organizations with a mediocre vision in a mediocre market with mediocre capabilities.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("Provide your new-hire candidates, existing top performers, and potential top performers with an opportunity for advancement. It could be advancement in their professional skills, scope of responsibility, type of work, or achieving a sizable goal. It could be a college education, master-level professional certification, industry accreditation, or a position with more authority. It could be a raise or promotion.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("If you don’t have a career roadmap that shows employees the advancements and career tracks available to them, create one. Use it to facilitate career planning discussions and to promote the exclusivity of achieving higher levels of performance. If, for example, you hire and employ designers, have multiple designer levels that employees can attain with increasing competence and experience. Be able to show your designers how they can elevate their skills and take on more responsibility to advance their careers.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Top performers place high value on professional growth. They became top performers because they learned, trained, practiced, and developed their skills. They value professional development. Regardless of position or title, offer to help them advance their skills. Give them opportunities to progress toward mastery in their current competencies and to create new competencies.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("Use your advancement and development opportunities to ")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("show ")]), _vm._v("your top performer candidates the tremendous respect you have for them. Promote all the learning aspects of your organization. "), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("Emphasize your coaching, training courses, team book clubs, ")]), _vm._v("and whatever else you make available to employees to help them develop. Explain the value you place on employee development and career advancement. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("Some managers are reluctant to help their employees develop and advance in their careers. As absurd as it seems, they think by inhibiting their employees’ professional growth and career advancement, their employees will be less valuable in the market and less likely to leave the organization. The problem, of course, is that this philosophy also makes the under-developed employees less valuable to the organization. It is not a winning strategy and certainly not a strategy that will retain top performers. Don’t hinder people’s advancement—either in their skills or responsibilities.")])]), _vm._v(" "), _c('p', {
    staticClass: "headline",
    attrs: {
      "id": "linking151"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESPECT")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text body-text-override"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("People have a fundamental need to feel valued and respected. The more respect you show people, the more satisfying their work is and the more likely they are to want to work for you. A new-hire candidate who feels respected is much more likely to want to work for you than one who feels merely number eighteen in your interviewing process.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("Show your respect for people by making them feel special. Don’t make remarks that cause new-hire candidates to feel they are merely one of many being considered for a position. Don’t make the interview so structured that they feel they are being run through a jury selection process. Don’t merely give candidates a dull boilerplate presentation and expect them to be enthusiastic about coming onboard.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("If you expect to hire your top prospects, give them personalized attention. Be a great host. Plan for their interview. Post their arrival on a reception welcome board in the lobby and let the receptionist know to expect them. Clean up your office, desk, or wherever you will be holding the interview. When they arrive, offer them a drink. Turn off your phone. Give them the best chair to sit in. Go out of your way to make them comfortable. Give them a tour of your facility. Introduce them to other people in your organization. Introduce them to the department head or president. Make a big deal out of their interview.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("Show candidates respect by recognizing their skills and ex")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("periences. After you’ve asked a question and explored their answer, assuming it’s a good answer, give them positive feedback. If they have attained their management objectives for the past sixteen quarters, verbally recognize it. If they mention an impressive accomplishment, acknowledge it. Your praise will make them feel good about themselves, your leadership style, and the type of environment they can expect to work in if they come onboard.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("Make the candidates who you want to hire feel like insiders. Allow them to feel what it would be like to be a part of your team. Introduce them to other top performers. Share with them your organization’s extraordinary capabilities. Give them a glimpse into your organization’s team spirit, creativity, competence, and professionalism. Highlight the remarkable features of your facilities and the perks of being an employee there. Do what you reasonably can to bring them into your environment and make them comfortable with it. Show them the same respect you would give a high-ranking dignitary. Make their interview a positive experience. Even if you don’t hire them, realize that they talk, have friends, and are potential recruiters of other candidates. Leave people with a positive lasting impression of both you and your organization.")])]), _vm._v(" "), _c('p', {
    staticClass: "headline",
    attrs: {
      "id": "linking152"
    }
  }, [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("FFER")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text body-text-override"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("The highest level of respect you have for people is revealed in what you are willing to invest in them. What you are willing to pay and do for a person says everything about what you expect and how much you value it. The salary, stock options, training, coaching, benefits, perks, and other resources you are willing to offer reveal what you think a person is truly worth.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When discussing prospective employees’ offers, describe the total investment you plan to make in them. Include all aspects of the investment, including what you will provide them in the way of facilities, support resources, and productivity tools. Provide details of the professional development they can expect, including training courses, coaching, and mentoring. Explain the formal programs as well as the informal activities they can expect to participate in. Review all the elements of their benefit package and financial compensation. Don’t take any elements of your offer for granted. Go over each in enough detail that a candidate fully appreciates its value.")]), _vm._v(" "), _c('div', {
    staticClass: "callout-text-frame"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/l1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "callout-text"
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEN DISCUSSING"), _c('br'), _vm._v(" PROSPECTIVE"), _c('br'), _vm._v(" EMPLOYEES’ OFFERS,"), _c('br'), _vm._v(" DESCRIBE THE TOTAL"), _c('br'), _vm._v(" INVESTMENT YOU PLAN"), _c('br'), _vm._v(" TO MAKE IN THEM.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/l1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("If you’ve presented your best offer and the candidate doesn’t commit, inquire to understand their objection. If they say the compensation is too low, don’t accept it as the true issue without discussion. If you discover your offer isn’t competitive with other offers or market salaries, you may need to raise your offer. However, you may uncover other issues behind their objection, such as the nature of the role you are offering. They might have a negative mental image of it or simply don’t understand it. Don’t negotiate over compensation when a candidate doesn’t really like or understand the role. Turn the conversation to the role. Ask questions about their understanding of the role and address their concerns with it first.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("Through questioning and deeper discussion with your candidate ")]), _vm._v("as explained in the section on inquiry in "), _c('span', [_vm._v("competency 17 in book 3")]), _vm._v(", you may discover a variety of issues during the interviewing process or following the presentation of your offer. Common issues, including those that masquerade as compensation issues, are a desire for more work variety, more schedule flexibility, the ability to work from home, and opportunities to advance. Uncover and address these underlying issues before you assume a person’s reluctance to come onboard is a compensation issue. Their real objection might be one you can accommodate without much difficulty.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("How you present an employment offer is also important. If a candidate’s first insight into your offer is a formal employment letter with legal disclaimers and drug testing requirements, you’ve not demonstrated much personalization or respect. A formal offer letter should recap what has already been discussed and agreed upon, not be the channel of new information. Before sending a candidate a formal offer of employment, review the details of the offer in a conversation. Uncover any concerns and resolve them. When everything is acceptable, then send the formal offer.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("When you as the hiring manager are recruiting top talent ")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("and making people an offer, you are selling as much as you are ")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("interviewing. As a good salesperson, review the compensation ")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("elements, attractive features of the job, future opportunity, and ")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("prestige of being part of a team of top performers. Emphasize the investment you are making in them and the professional ")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("development they can expect. Acknowledge their skills and how well aligned they are to the job requirements. Make them feel respected and valued.")])]), _vm._v(" "), _c('p', {
    staticClass: "headline"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TTRACTING")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OP")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALENT")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CORECARD")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text body-text-override"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("Measure how well you currently demonstrate the eight attributes of ")]), _c('span', {
    staticClass: "no-style-override-3"
  }, [_vm._v("Attracting Top Talent")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v(". Give yourself a “−,” “")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_c('img', {
    staticClass: "middle",
    attrs: {
      "alt": "",
      "src": "OEBPS/images/c.jpg"
    }
  }), _vm._v(",” or “+” for each attribute. Give a minus where you fall short, a check where you are adequate, and a plus where you are strong.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("If you have more pluses than minuses, give yourself a plus for your overall average. If you have more minuses than pluses, give yourself a minus for your overall average. If you have an equal number of pluses and minuses, give yourself a check for your overall average. Record your overall average score on the SCOPE of Leadership Scorecard provided in the appendix at the back of this book or on the full SCOPE of Leadership Scorecard provided in the appendix of book 1 of this series.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("To validate your overall self-assessment, ask others for their perceptions about the extent to which you attract, recruit, select, and hire top performers.")]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "98%"
    },
    attrs: {
      "cellpadding": "3",
      "cellspacing": "3"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "background-color": "#E7E7E8",
      "width": "80%"
    },
    attrs: {
      "align": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0em",
      "text-align": "left"
    }
  }, [_c('b', [_vm._v("Attribute")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background-color": "#E7E7E8",
      "width": "15%"
    },
    attrs: {
      "align": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0em",
      "text-align": "center"
    }
  }, [_c('b', [_vm._v("Score")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('ul', {
    staticStyle: {
      "margin-top": "1em",
      "margin-bottom": "0em",
      "margin-left": "0em"
    }
  }, [_c('li', [_c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("People Focus:")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v(" Do you focus more on people than tasks and endear others to you?")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "bottom"
    }
  }, [_c('p', {
    staticClass: "body-text body-text-override-2"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("____")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('ul', {
    staticStyle: {
      "margin-top": "1em",
      "margin-bottom": "0em",
      "margin-left": "0em"
    }
  }, [_c('li', [_c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("Competence: ")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("Do you display the competence and traits you are looking for in others?")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "bottom"
    }
  }, [_c('p', {
    staticClass: "body-text body-text-override-2"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("____")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('ul', {
    staticStyle: {
      "margin-top": "1em",
      "margin-bottom": "0em",
      "margin-left": "0em"
    }
  }, [_c('li', [_c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("Opportunity: ")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("Does your organization provide a compelling opportunity to perform interesting work and reach exciting accomplishments?")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "bottom"
    }
  }, [_c('p', {
    staticClass: "body-text body-text-override-2"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("____")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('ul', {
    staticStyle: {
      "margin-top": "1em",
      "margin-bottom": "0em",
      "margin-left": "0em"
    }
  }, [_c('li', [_c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("Need:")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v(" Do you have a clearly documented profile of the employee competencies and characteristics you need?")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "bottom"
    }
  }, [_c('p', {
    staticClass: "body-text body-text-override-2"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("____")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('ul', {
    staticStyle: {
      "margin-top": "1em",
      "margin-bottom": "0em",
      "margin-left": "0em"
    }
  }, [_c('li', [_c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("Fit: ")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("Do you use behavioral interviewing techniques to accurately assess a candidate’s abilities, proficiency level, and role fit?")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "bottom"
    }
  }, [_c('p', {
    staticClass: "body-text body-text-override-2"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("____")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('ul', {
    staticStyle: {
      "margin-top": "1em",
      "margin-bottom": "0em",
      "margin-left": "0em"
    }
  }, [_c('li', [_c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("Advancement: ")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("Do your positions provide opportunities for professional development and career advancement?")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "bottom"
    }
  }, [_c('p', {
    staticClass: "body-text body-text-override-2"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("____")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('ul', {
    staticStyle: {
      "margin-top": "1em",
      "margin-bottom": "0em",
      "margin-left": "0em"
    }
  }, [_c('li', [_c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("Respect:")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v(" Do you make candidates feel respected, valued, and as if they would be a special addition to the team?")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "bottom"
    }
  }, [_c('p', {
    staticClass: "body-text body-text-override-2"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("____")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('ul', {
    staticStyle: {
      "margin-top": "1em",
      "margin-bottom": "0em",
      "margin-left": "0em"
    }
  }, [_c('li', [_c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("Offer:")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v(" Do your employment offers reflect the value you place on candidates and emphasize the role’s nonmonetary benefits?")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "bottom"
    }
  }, [_c('p', {
    staticClass: "body-text body-text-override-2"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("____")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2"
    }
  }, [_c('br'), _c('br')])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background-color": "#E7E7E8"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "body-text body-text-override"
  }, [_c('span', {
    staticClass: "no-style-override"
  }, [_c('b', [_vm._v("Overall Average:")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background-color": "#E7E7E8"
    },
    attrs: {
      "valign": "bottom"
    }
  }, [_c('p', {
    staticClass: "body-text body-text-override-2"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("____")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "headline"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RINCIPLES IN")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVIEW")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text body-text-override"
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("Here are key principles from this chapter to keep in mind.")])]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "margin-top": "0em"
    }
  }, [_c('li', {
    staticStyle: {
      "margin-top": "7px"
    }
  }, [_c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("People:")]), _vm._v(" Place higher value on people and relationships than on tasks and activities.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-top": "7px"
    }
  }, [_c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("Model:")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v(" Manifest the competence and qualities you expect ")]), _vm._v("from others; like attracts like.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-top": "7px"
    }
  }, [_c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("Opportunity:")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v(" Provide a compelling employment oppor")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("tunity that includes interesting work and expectations of accomplishment.")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-top": "7px"
    }
  }, [_c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("Hiring Profile:")]), _vm._v(" Interview and hire to objective profiles of "), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("core requirements, but allow flexibility in nonessential ")]), _vm._v("qualities.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-top": "7px"
    }
  }, [_c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("Role Fit:")]), _vm._v(" Use behavioral interviewing questions to accurately assess a new-hire candidate’s proficiency.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-top": "7px"
    }
  }, [_c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("Promises: ")]), _vm._v("Don’t make promises that you know probably won’t be fulfilled.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-top": "7px"
    }
  }, [_c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("Advancement:")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v(" Provide opportunities for people to advance in their careers through skill mastery in addition to management promotion.")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-top": "7px"
    }
  }, [_c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("Hosting:")]), _vm._v(" Treat new-hire candidates with the respect you would a high-ranking dignitary.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-top": "7px"
    }
  }, [_c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("Offer:")]), _vm._v(" When making an employment offer, review all its valuable features including the attractive nature of the work, resources available, opportunities for accomplishment, professional development, and the general benefits of working for the organization.")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "ats",
    staticStyle: {
      "margin-top": "2.5em",
      "margin-bottom": "3em"
    }
  }, [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("THERS")]), _vm._v(":"), _c('br'), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVELOPING")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EOPLE")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text body-text-override-3",
    staticStyle: {
      "color": "#939598"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch01.htm"
    }
  }, [_c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("Competency 19: Attracting Top Talent")])])]), _vm._v(" "), _c('p', {
    staticClass: "body-text body-text-override-3"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch02.htm"
    }
  }, [_c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("Competency 20: Knowing the Individual")])])]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "margin-top": "0em"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch02.htm#linking153"
    }
  }, [_vm._v("Helper Mentality")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch02.htm#linking154"
    }
  }, [_vm._v("Time and Attention")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch02.htm#linking155"
    }
  }, [_vm._v("Acceptance")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch02.htm#linking156"
    }
  }, [_vm._v("Accessibility and Availability")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch02.htm#linking157"
    }
  }, [_vm._v("Relationship")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch02.htm#linking158"
    }
  }, [_vm._v("Accurate Perspective")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch02.htm#linking159"
    }
  }, [_vm._v("Observation")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch02.htm#linking160"
    }
  }, [_vm._v("Understanding")])])]), _vm._v(" "), _c('p', {
    staticClass: "body-text body-text-override-3",
    staticStyle: {
      "margin-top": "1.5em",
      "color": "#939598"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch03.htm"
    }
  }, [_c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("Competency 21: Coaching")])])]), _vm._v(" "), _c('p', {
    staticClass: "body-text body-text-override-3",
    staticStyle: {
      "color": "#939598"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch04.htm"
    }
  }, [_c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("Competency 22: Exhorting and Praising")])])]), _vm._v(" "), _c('p', {
    staticClass: "body-text body-text-override-3",
    staticStyle: {
      "color": "#939598"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch05.htm"
    }
  }, [_c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("Competency 23: Enabling Performance")])])]), _vm._v(" "), _c('p', {
    staticClass: "body-text body-text-override-3",
    staticStyle: {
      "color": "#939598"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch06.htm"
    }
  }, [_c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("Competency 24: Managing Performance")])])]), _vm._v(" "), _c('p', {
    staticClass: "body-text body-text-override-3",
    staticStyle: {
      "color": "#939598"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Hawkins_B4_Ch07.htm"
    }
  }, [_c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("Competency 25: Imparting Ownership")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29e07ccf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Hawkins_B4_Ch-01.vue
// module id = 78
// module chunks = 0